<template>
    <el-dialog custom-class="add-album-dialog" append-to-body :visible="visible" :show-close="false" width="600px" :before-close="handleClose">
        <div class="add-album">
            <div class="item">
                <div class="name">发布单曲</div>
                <!-- 未认证/未签约 -->
                <template v-if="$store.getters.userState <= 2">
                    <p>购买服务才可发布该类型</p>
                    <el-button v-if="$store.getters.userState == 1" type="info" @click="$router.push(goLink)">去认证</el-button>
                    <el-button v-if="$store.getters.userState == 2" type="info" @click="$router.push(goLink)">去签约</el-button>
                </template>
                <!-- 未试用 -->
                <template v-else-if="$store.getters.userState == 3">
                    <p>购买服务才可发布该类型</p>
                    <!-- <el-button type="primary" @click="$router.push(`/manage/album/singleTrackInfo/add?quantity=${quantity}&type=1`)">
                        去发布
                    </el-button> -->
                    <el-button type="info" @click="$router.push(goLink)">去购买服务</el-button>
                </template>
                <!-- 试用完成 -->
                <template v-else-if="$store.getters.userState == 4">
                    <p>购买服务才可发布该类型</p>
                    <el-button type="info" @click="$router.push(goLink)">去购买服务</el-button>
                </template>
                <!-- vip已过期 -->
                <template v-else-if="$store.getters.userState == 5">
                    <p>服务已过期</p>
                    <el-button type="info" v-if="$store.state.userType != 3" @click="$router.push(goLink)">续费使用</el-button>
                </template>
                <template v-else>
                    <p>这个世界需要你的音乐</p>
                    <div>
                        <el-button type="primary" @click="$router.push(`/manage/album/singleTrackInfo/add?quantity=${quantity}&type=1`)">
                            立即发布
                        </el-button>
                    </div>
                </template>
            </div>
            <div class="item">
                <div class="name">EP/专辑</div>
                <!-- 未购买VIP -->
                <template v-if="$store.getters.userState < 5">
                    <p>购买服务才可发布该类型</p>
                    <el-button type="info" @click="$router.push(goLink)">去购买服务</el-button>
                </template>
                <!-- vip已过期 -->
                <template v-else-if="$store.getters.userState == 5">
                    <p>服务已过期</p>
                    <el-button type="info" v-if="$store.state.userType != 3" @click="$router.push(goLink)">续费使用</el-button>
                </template>
                <template v-else>
                    <p>音乐作品的合集</p>
                    <el-button type="primary" @click="$router.push('/manage/album/add')">立即发布</el-button>
                </template>
            </div>
        </div>
    </el-dialog>
</template>

<script>
export default {
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        quantity: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {};
    },
    computed: {
        // 是否运行试用单曲专辑
        isTrialAlbum() {
            const {userData} = this.$store.state;
            return userData && userData.ifLimitAlbumForShowStart;
        },
        // 不同阶段跳转地址
        goLink() {
            const {userState, goContractSigned} = this.$store.getters;
            if (userState == 1) return this.$contractRouter('/manage/contract/verify/fdd/step/1', 'url');
            if (userState == 2) return this.$contractRouter(goContractSigned, 'url');
            if (userState == 3 || userState == 4 || userState == 5) return '/manage/pay';
            return '';
        },
    },
    watch: {},
    methods: {
        handleClose() {
            this.$emit('update:visible', false);
        },
    },
};
</script>
<style lang="scss">
@keyframes zoom {
    0% {
        transform: scale(0.96);
        /* 初始大小 */
    }

    100% {
        transform: scale(1.06);
        /* 最终大小 */
    }
}

.add-album-dialog {
    background: transparent;
    box-shadow: none;
}

.add-album {
    display: flex;

    .item {
        background: $--color-white;
        border-radius: 10px;
        padding: 40px 30px 30px;
        color: $-text-500;
        flex: 1;
        position: relative;
        overflow: hidden;
        text-align: center;

        &:hover {
            &::before {
                background: $--color-black;
            }
        }

        &::before {
            content: '';
            position: absolute;
            height: 10px;
            width: 100%;
            top: 0px;
            left: 0px;
            width: 100%;
            background: $-text-300;
        }

        &:first-child {
            margin-right: 20px;
        }

        .name {
            font-size: 24px;
            color: $-text-950;
            line-height: 24px;
            font-weight: bold;
            padding-top: 30px;
        }

        p {
            margin-top: 16px;
            font-size: 12px;
            line-height: 12px;
        }

        .icon-a-album {
            background: url('~@/assets/img/album/a-album.svg') no-repeat center;
            background-size: cover;
            width: 16px;
            height: 16px;
            display: inline-block;
            margin-right: 8px;
        }

        .el-button {
            margin-top: 40px;
        }
    }
}
</style>
